import { Modal } from '@material-ui/core';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';

import Button from '../buttons/Button';
import ControlledInput from '../inputs/ControlledInput';
import { deleteUserAccount } from '../../redux/user/actions';

const DeleteUserModal = ({ isOpen, handleClose }) => {
  const dispatch = useDispatch();
  const isPending = useSelector((state) => state.user.isIntranetLoading);

  const { control, watch } = useForm({ defaultValues: { password: '' } });
  const password = watch('password');
  const handleDeleteAccount = () => {
    dispatch(deleteUserAccount(password));
  };

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className="c-delete-user-modal">
      <div className="c-delete-user-modal__container">
        <p>
          ¿Estas seguro de que quieres eliminar tu perfil de organizador de la
          Agenda Virtual dels Ports?
        </p>
        <p>Introduce tu contraseña para validar la operación</p>
        <ControlledInput
          control={control}
          name="password"
          type="password"
          label="Contraseña"
        />
        <div className="c-delete-user-modal__actions-container">
          <Button
            isLoading={isPending}
            disabled={!password?.length}
            onClick={handleDeleteAccount}
            isActive>
            Eliminar
          </Button>
          <Button onClick={handleClose}>Cancelar</Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteUserModal;
